import { Component, computed, inject, input } from '@angular/core';
import { clsx } from 'clsx';

import { BadgeComponent } from '../badge/badge.component';
import { IconComponent, type Icon } from '../icon';
import { RadioBaseDirective } from '../radio-base/radio-base.directive';

export type RadioCardLayout = 'inline' | 'stacked';

@Component({
  selector: 'sb-radio-card',
  templateUrl: './radio-card.component.html',
  imports: [IconComponent, BadgeComponent],
  hostDirectives: [{ directive: RadioBaseDirective, inputs: ['value', 'checked', 'disabled', 'name', 'id'] }],
  host: {
    class: 'relative',
  },
})
export class RadioCardComponent {
  base = inject(RadioBaseDirective);

  icon = input<Icon>();
  badge = input<string>();
  // 'inline' keeps the icon beside the text (default); 'stacked' centers the icon above the text.
  layout = input<RadioCardLayout>('inline');

  labelClasses = computed(() =>
    clsx(
      'm-0 size-full cursor-pointer gap-sm select-none',
      'rounded-md border border-solid border-default bg-surface-page p-4',
      // No `outline-hidden`: it sets `--tw-outline-style: none`, which the
      // `peer-focus-visible:outline` ring below reads — hiding the focus ring.
      'text-base font-semibold text-default outline-offset-2',
      'hover:border-brand',
      'peer-checked:border-brand peer-checked:bg-brand-subtle',
      'peer-focus-visible:border-brand peer-focus-visible:outline peer-focus-visible:outline-2 peer-focus-visible:outline-brand',
      'peer-disabled:pointer-events-none peer-disabled:opacity-30',
      this.layout() === 'stacked' ? 'flex flex-col items-center text-center' : 'inline-flex',
    ),
  );
}
